import { FormControl } from 'baseui/form-control';
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader, SIZE } from 'baseui/modal';
import { useState } from 'react';
import { getValue } from '../utils';
import { TValueOption, ValueCellSelector } from '../ValueCell/ValueCellSelector';
import { useIntl, FormattedMessage } from 'react-intl';
import { addMinutes } from 'date-fns';
import { EditTimeRangeForm } from '../EditTimeRangeForm';

export interface EditEventDialogProps {
    isOpen: boolean,
    setIsOpen: any,
    onAccept: any,
    value: any,
    eventId: string,
    dataType: string,
    timeFrom: Date,
    timeTo: Date
    valueOptions?: TValueOption[] | undefined // if value is an enum - provide possible values here
}

export const EditEventDialog = (props: EditEventDialogProps) => {
    const intl = useIntl();
    const [state, setState] = useState({ value: getValue(props.dataType, props.value), timeFrom: props.timeFrom, timeTo: props.timeTo});

    function onValueChanged(newValue: any) {
        setState(prevState => ({
            ...prevState,     // keep all other key-value pairs
            value: newValue
        }))
    }
    function setTimeFrom(time: Date | null) {
        if ( !time )
            return;

        if (time >= state.timeTo)
            time = addMinutes(state.timeTo, -15);

        setState(prevState => ({
            ...prevState,     // keep all other key-value pairs
            timeFrom: time as Date
        }))
    }
    function setTimeTo(time: Date | null) {
        if ( !time )
            return;

        if (time <= props.timeFrom)
            time = addMinutes(props.timeFrom, 15);

        setState(prevState => ({
            ...prevState,     // keep all other key-value pairs
            timeTo: time as Date
        }))
    }
    
    return (
        <>
            <Modal closeable onClose={() => props.setIsOpen(false)} isOpen={props.isOpen}>
                <ModalHeader><FormattedMessage id="Scheduler.EditValue" defaultMessage="Edit Value" /></ModalHeader>
                <ModalBody>
                    <EditTimeRangeForm timeFrom={state.timeFrom} timeTo={state.timeTo} onTimeFromChange={setTimeFrom} onTimeToChange={setTimeTo}></EditTimeRangeForm>
                    <FormControl
                        label={() => intl.formatMessage({ id: "valueInput", defaultMessage: "Value" })}
                        caption={() => intl.formatMessage({ id: "valueInputDescription", defaultMessage: "Select a value" })}
                    >
                        <ValueCellSelector valueOptions={props.valueOptions}  dataType={props.dataType} value={state.value} onValueChanged={onValueChanged}></ValueCellSelector>
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <ModalButton kind="tertiary" onClick={() => { props.setIsOpen(false); }}>
                    <FormattedMessage id="cancel" defaultMessage="Cancel" />
                    </ModalButton>
                    <ModalButton onClick={() => { props.onAccept(state, props.eventId); props.setIsOpen(false) }}> <FormattedMessage id="ok" defaultMessage="Ok" /></ModalButton>
                </ModalFooter>
            </Modal>
        </>
    );
}




